// extracted by mini-css-extract-plugin
export default {"avatar":"style_avatar__j2Y5w"};